import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader, 
  // Accordion,
  // AccordionBody,
  // AccordionHeader,
  // AccordionItem, 
} from "reactstrap";
import { Accordion } from "./Accordion";

export default function BenchMarkDetailsModal({text}) {
  const [open, setOpen] = useState(false);
  // const [openRow, setOpenRow] = useState('1');
  
  // const toggleRow = (id) => {
  //   if (open === id) {
  //     setOpenRow();
  //   } else {
  //     setOpenRow(id);
  //   }
  // };
  
  return (
    <span id="dani-benchmark-details-modal">
      <span
        className="benchmark-example-link cursor-pointer"
        onClick={() => setOpen(true)}
      >
        {text? text:"Would you like to see the types of things I can help you with? Click here."}
      </span>
      <Modal
        isOpen={open}
        className="dashboardModalContainer dashboardModalDetailsContainer benchmark_chat_info"
      >
        <ModalHeader
          className="dashboardHeader"
          charCode="X"
          toggle={() => setOpen(!open)}
        >
          <div className="dashboardModalTitle">Sample Questions</div>
        </ModalHeader>
        <ModalBody>
        {/* <h6>Gudielines</h6> */}
        <div>
        <Accordion open={0}>
        <Accordion.Item>
          <Accordion.Header>Types of Questions</Accordion.Header>
          <Accordion.Body>
              <ul>
                {/* <li>Benchmarking data</li>  */}
                  {/* <ul className="sub-list-01">
                    <li>What is the annual compensation data on women in Management, professional, and related occupations</li>
                    <li>Can you provide the percentage of women in manufacturing in Texas</li>
                    <li>What is the demographic breakdown of the manufacturing industry</li>
                    <li>What is the percentages of women employees in all occupations in the US</li>
                    <li>What % of executives and managers who are women and/or members of underrepresented groups have executive sponsors</li>
                  </ul> */}
                <li>Processes, policies and benefits</li>
                  <ul className="sub-list-01">
                    <li>Best in class paternity leave policy in the US</li>
                    <li>How often should an organization train managers on unconscious bias</li>
                  </ul>
                <li>Best Practices</li>
              </ul>

          </Accordion.Body>
        </Accordion.Item>

        {/* <Accordion.Item>
          <Accordion.Header>Be Specific</Accordion.Header>
          <Accordion.Body>
            <ul >
              <li>Diversity, Industry, Occupation, Location can be specified to receive the desired results. </li>
                <ul className="sub-list-01">
                  <li>Can you provide the percentages of black employees in all occupations in the US as a table</li>
                  <li>Can you provide the percentage of women in all occupations in the US as a "csv"</li>
                  <li>Can you provide the percentage of women in manufacturing at different seniority levels as a "csv"</li>
                </ul>
              <li>To have data presented a list, specify the type of list you want the data presented as: "ordered list" or "unordered list".</li>
                <ul className="sub-list-01">
                    <li>Can you give me a list of activities for womens history month</li>
                    <li>Can you provide an ordered list of 12 Effective Recruitment Strategies to Attract Top Talent</li>
                  </ul>
            </ul>
          </Accordion.Body>
        </Accordion.Item> */}

        {/* <Accordion.Item>
          <Accordion.Header>some header 4</Accordion.Header>
          <Accordion.Body>some body 4</Accordion.Body>
        </Accordion.Item> */}


      </Accordion>
        {/* <Accordion open={openRow} toggle={toggleRow}>

          <AccordionItem>
            <AccordionHeader targetId="1">Accordion Item 1</AccordionHeader>
              <AccordionBody accordionId="1">
                <strong>This is the first item&#39;s accordion body.</strong>
                You can modify any of this with custom CSS or overriding our default
                variables. It&#39;s also worth noting that just about any HTML can
                go within the <code>.accordion-body</code>, though the transition
                does limit overflow.
              </AccordionBody>
          </AccordionItem>

        </Accordion> */}

        {/* <h5>Types of Questions</h5>
          <ul>
            <li>Benchmarking data</li> 
              <ul className="sub-list-01">
                <li>What is the annual compensation data on women in Management, professional, and related occupations</li>
                <li>Can you provide the percentage of women in manufacturing in Texas</li>
                <li>What is the demographic breakdown of the manufacturing industry</li>
                <li>What is the percentages of women employees in all occupations in the US</li>
                <li>What % of executives and managers who are women and/or members of underrepresented groups have executive sponsors</li>
              </ul>
            <li>Processes, policies and benefits</li>
              <ul className="sub-list-01">
                <li>Best in class paternity leave policy in the US</li>
                <li>How often should an organization train managers on unconscious bias</li>
              </ul>
            <li>Best Practices</li>
          </ul>
        <h5>Be Specific</h5>
          <ul >
            <li>Diversity, Industry, Occupation, Location can be specified to receive the desired results. </li>
            <li>With types of data that can be presented in a table ("as a table") or as csv, make sure to include in your question as well.</li>
              <ul className="sub-list-01">
                <li>Can you provide the percentages of black employees in all occupations in the US as a table</li>
                <li>Can you provide the percentage of women in all occupations in the US as a "csv"</li>
                <li>Can you provide the percentage of women in manufacturing at different seniority levels as a "csv"</li>
              </ul>
          </ul> */}

        </div>
        </ModalBody>
      </Modal>
    </span>
  );
}
